import React, { useEffect, useState } from 'react';
import ResultInfoScreen from '../result-info-screen';
import WelcomeChallengeScreen from '../welcome-challenge-screen';
import Progress from './Progress';

export default function FourOptionsChallenge({
  setScreenNumber,
  type,
  backgroundImage
}) {
  const [status, setStatus] = useState('start'); // start | in_progress | finished
  const [step, setStep] = useState(0);
  const [data, setData] = useState();

  useEffect(() => {
    (async () => {
      const { start, challengeList, finish } = await import(
        `./utils/${type}.js`
      );
      const [_start, _challengeList, _finish] = await Promise.all([
        start,
        challengeList,
        finish
      ]);
      setData({
        start: _start,
        challengeList: _challengeList,
        finish: _finish
      });
    })();
  }, [type]);

  if (status === 'start')
    return (
      <WelcomeChallengeScreen
        setScreenNumber={setScreenNumber}
        backgroundImage={backgroundImage}
        title={data?.start.title}
        description={data?.start.description}
        buttonTitle={data?.start.button}
        setNextScreenNumber={() => setStatus('in_progress')}
        style="lm-four-option"
      />
    );
  if (status === 'in_progress')
    return (
      <Progress
        list={data?.challengeList}
        setScreenNumber={setScreenNumber}
        backgroundImage={backgroundImage}
        step={step}
        setStep={setStep}
        setStatus={setStatus}
      />
    );
  if (status === 'finished')
    return (
      <ResultInfoScreen
        setScreenNumber={setScreenNumber}
        setNextScreenNumber={() => setScreenNumber(10)}
        title={data?.finish.title}
        description={data?.finish.description}
        image={data?.finish.image}
        backgroundImage={backgroundImage}
        style="lm-four-option"
      />
    );
}
